<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">子商户管理</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
           <el-form-item label="商户" prop="BusinessCode">
              <el-select  filterable placeholder="请选择"  v-model="BusinessCode" :disabled="BusinessCodeDisabled" clearable>
                <el-option
                  v-for="item in Businesses"
                  :key="item.BusinessCode"
                  :label="item.BusinessName"
                  :value="item.BusinessCode">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="子商户" prop="ChildBusinessCode">
              <el-select  filterable placeholder="请选择"  v-model="ChildBusinessCode" :disabled="ChildBusinessCodeDisabled" clearable>
                <el-option
                  v-for="item in ChildBusinesses"
                  :key="item.ChildBusinessCode"
                  :label="item.ChildBusinessName"
                  :value="item.ChildBusinessCode">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="子商户类型" prop="BusinessTypeId">
              <el-select  filterable placeholder="请选择"  v-model="BusinessType_Id" clearable>
                <el-option
                  v-for="item in BusinessTypes"
                  :key="item.BusinessTypeId"
                  :label="item.BusinessTypeName"
                  :value="item.BusinessTypeId">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item class="right">
            <el-button @click="onSearch">查 询</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="ChildBusinessCode" label="子商户编号"></el-table-column>
              <el-table-column prop="ChildBusinessName" label="子商户名称"></el-table-column>
              <el-table-column prop="Description" label="备注">
                <template slot-scope="scope">
                  <el-popover placement="top-start" title="备注" width="250" trigger="hover">
                    <div>{{scope.row.Description}}</div>
                    <span
                      slot="reference"
                    >{{ (scope.row.Description!=null &&scope.row.Description.length>15)?scope.row.Description.substr(0,15)+'...':scope.row.Description }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="220" align="center">
                <template slot-scope="scope">
                  <el-button 
                    @click="qrCodeClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >二维码</el-button>
                  <el-button
                    @click="queryClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                  <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                  <el-button
                    @click="deleteClick(scope.$index,scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5,10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <ZjDialog
      :title="dilaogconfig.title"
      :dialogFormVisible="dilaogconfig.dialogFormVisible"
      :width="dilaogconfig.width"
      :height="dilaogconfig.height"
      @clickCancel="handleDialogCancel"
    >
      <ChildBusinessInfoPage
        @clickOk="handleDialogOk"
        @clickCancel="handleDialogCancel"
        :ChildBusiness_Id="SelectedChildBusinessId"
        :IsEdit="IsEdit"
        :IsFinish="IsFinish"
      ></ChildBusinessInfoPage>
    </ZjDialog>
    <ZjDialog
      :title="QRconfig.title"
      :dialogFormVisible="QRconfig.dialogFormVisible"
      :width="QRconfig.width"
      :height="QRconfig.height"
      @clickCancel="handleQRDialogCancel"
    >
      <QRCodePage
        @clickCancel="handleQRDialogCancel"
        :Business_Code="SelectBusiness_Code"
        :ChildBusiness_Code="SelectChildBusiness_Code"
      ></QRCodePage>
    </ZjDialog>
  </div>
</template>

<script>
import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";
import ChildBusinessInfoPage from "./childbusinessinfo.vue";
import QRCodePage from "./QRCode.vue";


export default {
  name: "ChidBusinessPage",
  controller: "UI",
  action: "ChildBusinesses",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      Orgs: null,
      Businesses:[],
      BusinessCode:"",
      BusinessCodeDisabled:false,
      ChildBusinesses:[],
      ChildBusinessCode:"",
      ChildBusinessCodeDisabled:false,
      BusinessType_Id:"",
      tableHeight: window.innerHeight - 440,
      dilaogconfig: {
        title: "添加子商户",
        dialogFormVisible: false,
        width: "1200px",
      },
      QRconfig:{
        title:"二维码",
        dialogFormVisible: false,
         width: "370px",
         height:"400px"
      },
      multipleSelection: [],
      IsEdit: true,
      IsFinish:false,
      BusinessTypes:[]
    };
  },
  components: {
    ChildBusinessInfoPage,
    QRCodePage
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  created: function () {
    this.GetChidBusinessType();
    this.init();
  },
  mounted: function () {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.tableHeight = window.innerHeight - 440;
      })();
    };
    this.logInfo.ActionName = "子商户管理查看";
    this.logInfo.LogMessage = "子商户管理查看";
    this.logInfo.ModuleName = "统一管理";
    this.logInfo.PageName = "子商户信息";
    this.addOperationLog();
  },
  computed: {},
  watch:{
    BusinessCode(val){
      this.ChildBusinessCode="";
      this.GetChildBusinessesByBusiness(val);
    }
  },
  methods: {
    // 初始化
    init() {
      let user = this.user;

      if(user.LoginName!="admin")
      {
        this.BusinessCode=user.LoginName;
        this.BusinessCodeDisabled=true;
      }
      else
      {
        this.BusinessCode="";
        this.BusinessCodeDisabled=false;
      }
      return utils.waitAll([
                            () => this.GetBusiness()
                          ]).then(()=>{

                             this.GetChildBusinesses()
                          });
    }, 
    GetBusiness(){
        return new WebApis.BusinessApi()
        .FindAll()
        .then((r) => {
          console.log(r);
          r = r.data.Data;
          this.Businesses = r;
          this.InitChildBusiness()
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取商户数据异常！" + e.RspMsg
              : "获取商户数据异常！",
            type: "error",
          });
        });
    },
    InitChildBusiness()
    {
      let user = this.user;

      if(user.LoginName!="admin")
      {
          var SelectedBusiness= this.GetBusinessByUser(user);

          if(SelectedBusiness)
          {
            this.BusinessCode = SelectedBusiness.BusinessCode;
            if(SelectedBusiness.IsMain=="1")
            {
               this.BusinessCode="";
               this.BusinessCodeDisabled=false;
            }
          }

          if(!this.BusinessCode)
          {
              this.GetChildBusinessByChildBusinessCode(user.LoginName);
          }
          else
          {
              this.GetChildBusinessesByBusiness(this.BusinessCode);
              this.BusinessCodeDisabled=true;
          }
      }
      else
      {
        this.BusinessCode="";
        this.BusinessCodeDisabled=false;
      }
    },
    GetBusinessByUser(user)
    {
       var result="";
        this.Businesses.forEach(function(item){
            if(item.BusinessCode==user.LoginName)
            {
              result = item;
              return;
            }
        });
        return result;
    },
     GetChildBusinessByChildBusinessCode(ChildBusinessCode)
    {
       let ChildBusinessSearch = {
        ChildBusinessCode:ChildBusinessCode
      };

      new WebApis.ChildBusinessApi()
        .GetItemByBusinessCodeAndChildBusinessCode(ChildBusinessSearch)
        .then((r) => {
          var result = r.data.Data;
          if(result)
          {
            this.BusinessCode = result.BusinessCode;
            this.BusinessCodeDisabled=true;
            utils.waitAll([
                      () => this.GetChildBusinessesByBusiness(this.BusinessCode)
                    ]).then(()=>{
                        this.ChildBusinessCode = result.ChildBusinessCode;
                        this.ChildBusinessCodeDisabled=true;
                    });
          }
          
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取子商户数据异常！" + e.RspMsg
              : "获取子商户数据异常！",
            type: "error",
          });
        });
    },
    GetChidBusinessType()
    {
      return new WebApis.BusinessTypeApi().FindAll().then((res)=>{
          if (res.data.Data) {
                  this.BusinessTypes=res.data.Data;
          }
       });
    },
     GetChildBusinessesByBusiness(BusinessCode) {

      let ChildBusinessSearch = {
        BusinessCode:BusinessCode
      };

      return new WebApis.ChildBusinessApi()
        .FindByConditions(ChildBusinessSearch)
        .then((r) => {
          this.ChildBusinesses = r.data.Data;
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取子商户数据异常！" + e.RspMsg
              : "获取子商户数据异常！",
            type: "error",
          });
        });
    },
    GetChildBusinesses() {
      showLoading(".zj-table-container");

      let ChildBusinessSearch = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        ChildBusinessCode: this.ChildBusinessCode!=""?this.ChildBusinessCode:null,
        BusinessCode:this.BusinessCode!=""?this.BusinessCode:null,
        ChildBusinessName: this.ChildBusiness_Name!=""?this.ChildBusiness_Name:null,
        BusinessTypeId:this.BusinessType_Id!=""?this.BusinessType_Id:null,
        TotalCount: 0,
      };

      console.log(ChildBusinessSearch);
      return new WebApis.ChildBusinessApi()
        .GetPageContentByConditions(ChildBusinessSearch)
        .then((r) => {
          console.log(r);
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          hideLoading();
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取子商户数据异常！" + e.RspMsg
              : "获取子商户数据异常！",
            type: "error",
          });
          hideLoading();
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage=1;
      this.GetChildBusinesses();
    },
    clearsearch() {
      this.ChildBusiness_Code = "";
      this.ChildBusiness_Name = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.GetChildBusinesses();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetChildBusinesses();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetChildBusinesses();
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() +
        "年" +
        date.getMonth() +
        "月" +
        date.getDate() +
        "日"
      );
    },
    onAdd() {
      this.SelectedChildBusinessId = "";
      this.IsEdit = true;
      this.IsFinish=false;
      this.dilaogconfig.dialogFormVisible = true;
    },
    selectionChange(val) {
      this.multipleSelection = val;
    },
    //已维护在组织机构中，不能删除
    canDelete(selectData, callback) {
      let arr = [];
      for (let i = 0; i < selectData.length; i++) {
        new WebApis.OrgApi()
          .GetItemById({
            OrgId: selectData[i].ChidBusinessId,
          })
          .then((r) => {
            var data = r.data.Data;
            if (data!=null) {
              this.$message.error(
                selectData[i].ChidBusinessName + "已维护在组织机构中，不能删除"
              );
              arr.push({ isDelete: false });
            } else {
              arr.push({ isDelete: true });
            }
            callback(arr);
          })
          .catch((e) => {
            console.log(e);
            this.$message({
              showClose: true,
              message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
              type: "error",
            });
          });
      }
    },
    onbatchDel() {
      let ChidBusiness_Ids = [];
      this.multipleSelection.forEach((item) => {
        ChidBusiness_Ids.push(item.ChidBusinessId);
      });

      if (ChidBusiness_Ids.length <= 0) {
        this.$message({
          showClose: true,
          message: "请选择要删除的数据!",
          type: "warning",
        });
        return;
      }
      this.$confirm("确定删除选中子商户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ChildBusinessSearch = {
          ChidBusinessIds: ChidBusiness_Ids,
        };
        console.log(ChildBusinessSearch);
        const that = this;
        that.canDelete(that.multipleSelection, function (data) {
          const index = data.findIndex((item) => item.isDelete == false);
          if (index == -1 && data.length == ChidBusiness_Ids.length) {
            new WebApis.ChildBusinessApi()
              .DelItemList(ChildBusinessSearch)
              .then((r) => {
                if (r.RspCode == "1") {
                  that.$message({ type: "success", message: "删除成功!" });
                  that.GetChildBusinesses();
                } else {
                  that.$message({
                    showClose: true,
                    message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                    type: "error",
                  });
                }
                that.logInfo.ActionName = "子商户删除";
                that.logInfo.LogMessage =
                  r.RspCode == "1" ? "子商户删除成功" : "删除子商户失败";
                that.logInfo.ModuleName = "统一管理";
                that.logInfo.PageName = "子商户管理列表页面";
                that.addOperationLog();
              })
              .catch((e) => {
                that.$message({
                  showClose: true,
                  message: e.RspMsg
                    ? "删除失败!" + e.RspMsg
                    : "获取子商户信息失败!",
                  type: "error",
                });
              });
          } else {
            return;
          }
        });
      });
    },
    queryClick(index, row) {
      this.SelectedChildBusinessId = row.ChildBusinessId;
      this.IsEdit = false;
      this.IsFinish = false;
      this.dilaogconfig.title = "查看子商户";
      this.dilaogconfig.dialogFormVisible = true;
    },
    editClick(index, row) {
      this.SelectedChildBusinessId = row.ChildBusinessId;
      this.IsEdit = true;
      this.IsFinish = false;
      this.dilaogconfig.title = "修改子商户";
      this.dilaogconfig.dialogFormVisible = true;
    },
    qrCodeClick(index, row) {
      this.SelectBusiness_Code = row.BusinessCode;
      this.SelectChildBusiness_Code= row.ChildBusinessCode;
      this.QRconfig.title = "二维码";
      this.QRconfig.dialogFormVisible = true;
    },
    reviewClick(index, row) {
      this.SelectedChildBusinessId = row.ChildBusinessId;
      this.IsEdit = false;
      this.IsFinish = true;
      this.dilaogconfig.title = "提交审核";
      this.dilaogconfig.dialogFormVisible = true;
    },
    deleteClick(index, row) {
      this.SelectedChildBusinessId = row.ChildBusinessId;
      this.$confirm("确定删除该产品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ChildBusinessSearch = {
          ChildBusinessId: this.SelectedChildBusinessId,
        };
        const that = this;
        that.canDelete([row], function (data) {
          const index = data.findIndex((item) => item.isDelete == false);
          if (index != -1) {
            return;
          } else {
            new WebApis.ChildBusinessApi()
              .DelItemByChildBusinessId(ChildBusinessSearch)
              .then((r) => {
                console.log("删除成功",r);
                if (r.RspCode == "1") {
                  that.$message({ type: "success", message: "删除成功!" });
                  that.GetChildBusinesses();
                } else {
                  that.$message({
                    showClose: true,
                    message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                    type: "error",
                  });
                }
                that.logInfo.ActionName = "子商户删除";
                that.logInfo.LogMessage =
                  r.RspCode == "1" ? "子商户删除成功" : "删除子商户失败";
                that.logInfo.ModuleName = "统一管理";
                that.logInfo.PageName = "子商户列表";
                that.addOperationLog();
              })
              .catch((e) => {
                console.log(e);
                that.$message({
                  showClose: true,
                  message: e.RspMsg
                    ? "删除失败!" + e.RspMsg
                    : "获取产品信息失败!",
                  type: "error",
                });
              });
          }
        });
      });
    },
    handleDialogOk() {
      this.dilaogconfig.dialogFormVisible = false;
      this.GetChildBusinesses();
    },
    handleDialogCancel() {
      this.dilaogconfig.dialogFormVisible = false;
    },
    handleQRDialogCancel() {
      this.QRconfig.dialogFormVisible = false;
    }
  }
};
</script>